<template>
  <b-modal
    :id="id"
    :title="$t('investorContrat.chooseModal.title')"
    cancel-variant="outline-primary"
    centered
    hide-footer
  >
    <div v-if="selectedItem" class="choose-contrat-modal">
      <p class="choose-question">
        {{ $t('investorContrat.chooseModal.question') }}
      </p>
      <b-list-group class="choose-list">
        <b-list-group-item
          v-if="selectedItem.idAvp"
          button
          class="choose-item"
          @click="choose('avp')"
        >
          <span class="choose-badge bilan-avp">{{ $t('investorContrat.chooseModal.avp') }}</span>
          <span class="choose-name">— {{ selectedItem.name }}</span>
          <span class="choose-name">&nbsp;—&nbsp;{{ formatCurrency(selectedItem.avp.initialPayment) }}</span>
        </b-list-group-item>
        <b-list-group-item
          v-if="selectedItem.idExe"
          button
          class="choose-item"
          @click="choose('exe')"
        >
          <span class="choose-badge bilan-exe">{{ $t('investorContrat.chooseModal.exe') }}</span>
          <span class="choose-name">— {{ selectedItem.name }}</span>
          <span class="choose-name">&nbsp;—&nbsp;{{ formatCurrency(selectedItem.exe.initialPayment) }}</span>
        </b-list-group-item>
      </b-list-group>
    </div>

  </b-modal>
</template>

<script>
export default {
  name: "InvestorContratChooseModal",
  props: {
    selectedItem: Object,
    id: {
      type: String,
      default: "investor-contrat-choose-modal"
    },
    mode: {
      type: String, // "edit" ou "delete"
      required: true
    }
  },
  methods: {
    choose(type) {
      let id = type === "avp" ? this.selectedItem.idAvp : this.selectedItem.idExe
      if (this.mode === "edit") {
        this.$router.push({
          name: "InvestorContratCreateEdit",
          params: {investorContratId: id}
        })
      } else if (this.mode === "delete") {
        this.$emit("chooseDelete", id)
      }
      this.$bvModal.hide(this.id)
    },

    formatCurrency(value) {
      if (!value && value !== 0) return ''
      return Intl.NumberFormat().format((value / 100).toFixed(2)) + ' €'
    },
  }
}
</script>
<style scoped>
.choose-contrat-modal {
  padding: 0.5em 0;
}


.choose-list {
  border: none;
}

.choose-item {
  display: flex;
  align-items: center;
  border: 1px solid var(--main-color);
  border-radius: 6px;
  margin-bottom: 0.5em;
  transition: all 0.2s ease-in-out;
  font-family: "Montserrat-Medium", "Arial", sans-serif;
}

.choose-item:hover {
  cursor: pointer;
  border-color: var(--main-color-hover);
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.1);
}

.choose-badge {
  display: inline-block;
  min-width: 60px;
  text-align: center;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: bold;
  color: #fff;
  margin-right: 0.5em;
}

.choose-badge-avp {
  background-color: #317B22;
}

.choose-badge-exe {
  background-color: var(--main-color-hover);
}

.choose-name {
  font-size: var(--content-font-size);
  color: var(--main-text-color);
}

</style>



// WEBPACK FOOTER //
// src/views/investor/components/InvestorContratChooseModal.vue